import { getPosts } from "./postsAPI";

const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

const initialState = {
  posts: [],
  filteredPosts: [],
  isLoading: false,
  isError: false,
  error: "",
  status: [],
};

// async thunk
export const fetchPosts = createAsyncThunk("posts/fetchPosts", async () => {
  const posts = await getPosts();
  return posts;
});

const postsSlice = createSlice({
  name: "posts",
  initialState,
  reducers: {
    allSelected: (state, action) => {
      // brings all the posts form "posts" to "filteredPosts"
      state.filteredPosts = state.posts;
    },
    SavedSelected: (state, action) => {
      // state.posts = state.posts.filter((post) => post.isSaved);

      // filters only in the filteredPosts state
      state.filteredPosts = state.filteredPosts.filter((post) => post.isSaved);
    },
    newestSelected: (state, action) => {
      // function to convert date to Number form sorting
      const dateToNum = (date) => Number(date.split("-").join(""));
      // state.posts = state.posts.sort((a, b) =>
      //   // console.log(dateToNum(a.createdAt), dateToNum(b.createdAt))
      //   dateToNum(a.createdAt) > dateToNum(b.createdAt) ? -1 : 1
      // );

      // trying to solve a bug
      if (!state.status.includes("newestSelected")) {
        state.status.push("newestSelected");
      }

      // sorts only in the filteredPosts
      state.filteredPosts = state.filteredPosts.sort((a, b) =>
        // console.log(dateToNum(a.createdAt), dateToNum(b.createdAt))
        dateToNum(a.createdAt) > dateToNum(b.createdAt) ? -1 : 1
      );
    },
    mostLikedSelected: (state, action) => {
      // state.posts = state.posts.sort((a, b) =>
      //   a.likes < b.likes ? 1 : b.likes < a.likes ? -1 : 0
      // );

      // trying to solve a bug
      if (!state.status.includes("mostLikedSelected")) {
        state.status.push("mostLikedSelected");
      }
      // sorts only in the flteredPosts according to likes
      state.filteredPosts = state.filteredPosts.sort((a, b) =>
        a.likes < b.likes ? 1 : b.likes < a.likes ? -1 : 0
      );
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchPosts.pending, (state) => {
        state.isError = false;
        state.isLoading = true;
      })
      .addCase(fetchPosts.fulfilled, (state, action) => {
        state.isLoading = false;
        state.posts = action.payload;
        state.filteredPosts = action.payload;
      })
      .addCase(fetchPosts.rejected, (state, action) => {
        state.isLoading = false;
        state.posts = [];
        state.isError = true;
        state.error = action.error?.message;
      });
  },
});

export const { SavedSelected, newestSelected, mostLikedSelected, allSelected } =
  postsSlice.actions;
export default postsSlice.reducer;
